import {  HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse } from '@angular/common/http/';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {from} from "rxjs/observable/from"
import {_throw} from "rxjs/observable/throw"
import { map, catchError, switchMap } from 'rxjs/operators';


import { Storage } from '@ionic/storage'


const STORAGE_KEY = 'access_token';
const AUTH_HEADER = 'Authorization';
let jwt:any;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    
    constructor(private storage: Storage){
        
    }
    

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return from(this.storage.get(STORAGE_KEY))
            .pipe(
                switchMap(token => {
                    if (token) {
                        request = request.clone({ headers: request.headers.set('Authorization', token) });
                    }

                    if (!request.headers.has('Content-Type')) {
                        request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
                    }

                    return next.handle(request).pipe(
                        map((event: HttpEvent<any>) => {
                            if (event instanceof HttpResponse) {
                            }
                            return event;
                        })
                    );
                })
            );
    }
}


// WEBPACK FOOTER //
// ./src/interceptors/token.interceptor.ts